import { z } from 'zod/v4';

import { normalizeLogoWidgetArgs } from './logo-widget-args.normalization';
import { partialLogoWidgetDataSchema } from './partial-logo-widget-data.schema';

const updateLogoWidgetObjectSchema = z.object({
    widgetId: z.string().describe('Id of the logo widget to update.'),
    data: partialLogoWidgetDataSchema.describe(
        'Partial patch — only the fields you provide are changed, everything else is left as-is.'
    ),
});

export const updateLogoWidgetArgsSchema = z.preprocess(normalizeLogoWidgetArgs, updateLogoWidgetObjectSchema);
